import script from "./RelatedSection.vue?vue&type=script&lang=ts&setup=true"
export * from "./RelatedSection.vue?vue&type=script&lang=ts&setup=true"

import "./RelatedSection.vue?vue&type=style&index=0&id=bf2e1a3e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bf2e1a3e"]])

export default __exports__